import '../../../styles/index.css'
import './OrdenarPor.css';
import OrderIcon from '../../../assets/icons/Order Icon.svg'

function OrdenarPor({ordem, onClick}) {

    return (

        <button className='botaoOrdenarPor' onClick={onClick} data-cy="botao-ordenar-trigger">
            <img src={OrderIcon} alt="" />
            <span className='bt3'>{`Ordenar por: ${ordem} Preço`}</span>
        </button>

    );
}

export default OrdenarPor;
